import { createApp } from 'vue';
import App from './App.vue';
import './assets/styles.css'; // Custom styles

createApp(App).mount('#app');
